module.exports = __webpack_public_path__ + "static/media/dance.95b8a6c1.jpg";